var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _ellipse2, _ellipse3, _path22, _ellipse4, _ellipse5, _ellipse6, _path23, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1074.392 584.231",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#f2f2f2",
    ry: 34.922,
    rx: 527.5,
    cy: 549.309,
    cx: 540.643
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M520.426 167.01c-85.944 0-147.651 55.14-147.651 183.798 0 145.813 61.707 184.41 147.65 184.41s151.328-42.273 151.328-184.41c0-151.94-65.383-183.798-151.327-183.798zm.565 319.808c-59.527 0-90.626-34.923-90.626-135.916 0-89.112 32.372-136.105 91.899-136.105s91.899 30.868 91.899 136.105c0 98.447-33.646 135.916-93.172 135.916z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M321.311 433.517h-35.534v-104.64a20.956 20.956 0 0 0-20.956-20.956h-8.326a20.956 20.956 0 0 0-20.956 20.956v104.64h-100.23a11.963 11.963 0 0 1-10.578-17.552l106.083-200.78a20.956 20.956 0 0 0-9.58-28.74l-6.263-2.957a20.956 20.956 0 0 0-27.43 9.07L58.162 434.591a28.416 28.416 0 0 0-3.357 13.396 28.416 28.416 0 0 0 28.416 28.416H235.54v66.167a25.119 25.119 0 0 0 25.119 25.12 25.119 25.119 0 0 0 25.119-25.12v-66.167h35.534a21.443 21.443 0 0 0 21.443-21.443 21.443 21.443 0 0 0-21.443-21.443zM979.308 433.517h-35.534v-104.64a20.956 20.956 0 0 0-20.956-20.956h-8.327a20.956 20.956 0 0 0-20.956 20.956v104.64h-100.23a11.963 11.963 0 0 1-10.577-17.552l106.082-200.78a20.956 20.956 0 0 0-9.58-28.74l-6.263-2.957a20.956 20.956 0 0 0-27.429 9.07L716.157 434.591a28.416 28.416 0 0 0-3.356 13.396 28.416 28.416 0 0 0 28.416 28.416h152.318v66.167a25.119 25.119 0 0 0 25.12 25.12 25.119 25.119 0 0 0 25.118-25.12v-66.167h35.535a21.443 21.443 0 0 0 21.443-21.443 21.443 21.443 0 0 0-21.443-21.443z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M331.114 421.263H295.58V316.624a20.956 20.956 0 0 0-20.956-20.956h-8.327a20.956 20.956 0 0 0-20.956 20.956v104.64h-100.23a11.963 11.963 0 0 1-10.577-17.553l106.082-200.78a20.956 20.956 0 0 0-9.58-28.739l-6.263-2.957a20.956 20.956 0 0 0-27.429 9.07L67.963 422.338a28.416 28.416 0 0 0-3.356 13.396 28.416 28.416 0 0 0 28.416 28.416H245.34v66.167a25.119 25.119 0 0 0 25.12 25.119 25.119 25.119 0 0 0 25.119-25.12V464.15h35.534a21.443 21.443 0 0 0 21.443-21.443 21.443 21.443 0 0 0-21.443-21.444zM997.688 421.263h-35.535V316.624a20.956 20.956 0 0 0-20.956-20.956h-8.326a20.956 20.956 0 0 0-20.956 20.956v104.64h-100.23a11.963 11.963 0 0 1-10.577-17.553l106.082-200.78a20.956 20.956 0 0 0-9.58-28.739l-6.263-2.957a20.956 20.956 0 0 0-27.43 9.07l-129.38 242.033a28.416 28.416 0 0 0-3.356 13.396 28.416 28.416 0 0 0 28.415 28.416h152.32v66.167a25.119 25.119 0 0 0 25.118 25.119 25.119 25.119 0 0 0 25.12-25.12V464.15h35.534a21.443 21.443 0 0 0 21.443-21.443 21.443 21.443 0 0 0-21.443-21.444zM540.03 155.982c-85.943 0-147.65 55.14-147.65 183.798 0 145.813 61.707 184.41 147.65 184.41s151.328-42.273 151.328-184.41c0-151.94-65.383-183.798-151.327-183.798zm.566 319.808c-59.527 0-90.626-34.923-90.626-135.916 0-89.112 32.372-136.105 91.899-136.105s91.899 30.868 91.899 136.105c0 98.447-33.645 135.916-93.172 135.916z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M1006.864 419.55a20.813 20.813 0 1 0 2.771-39.916l.521 10.713-5.068-9.18a20.734 20.734 0 0 0-10.683 11.722 20.408 20.408 0 0 0-1.198 5.63 20.809 20.809 0 0 0 13.657 21.03z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M1031.941 543.793c-1.789-9.11 5.963-17.187 13.621-22.436s16.605-10.408 19.218-19.317c3.755-12.804-7.43-24.53-16.136-34.642a125.3 125.3 0 0 1-16.523-24.557c-1.812-3.533-3.476-7.226-3.953-11.167-.686-5.675 1.137-11.323 2.974-16.736q9.18-27.052 19.629-53.65"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M1007.72 416.792a20.813 20.813 0 1 0 2.773-39.916l.52 10.713-5.068-9.18a20.734 20.734 0 0 0-10.683 11.722 20.408 20.408 0 0 0-1.197 5.63 20.809 20.809 0 0 0 13.656 21.03z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M1029.397 357.588a20.788 20.788 0 0 1 14.98-13.197l1.714 10.183 3.177-10.695a20.81 20.81 0 1 1-19.87 13.71z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M1030.54 353.91a20.788 20.788 0 0 1 14.98-13.197l1.714 10.184 3.177-10.696a20.81 20.81 0 1 1-19.87 13.71z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M1044.99 467.604a20.81 20.81 0 0 0 18.42-37.022l-2.441 8.219-1.732-10.304a.362.362 0 0 0-.053-.02 20.811 20.811 0 1 0-14.193 39.127z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M1045.981 463.88a20.81 20.81 0 0 0 18.419-37.023l-2.441 8.22-1.731-10.305a.362.362 0 0 0-.053-.02 20.811 20.811 0 1 0-14.194 39.128z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M1023.324 502.167a20.801 20.801 0 1 0 4.01-16.297l9.273 13.956-12.67-7.408a20.616 20.616 0 0 0-.613 9.749z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M1024.18 499.409a20.801 20.801 0 1 0 4.012-16.297l9.272 13.956-12.67-7.407a20.616 20.616 0 0 0-.613 9.748z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M9.007 470.249a13.674 13.674 0 1 0 1.821-26.225l.343 7.038-3.33-6.032a13.623 13.623 0 0 0-7.02 7.702 13.409 13.409 0 0 0-.786 3.7 13.672 13.672 0 0 0 8.972 13.817z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M25.484 551.879c-1.176-5.986 3.918-11.292 8.949-14.741s10.91-6.838 12.626-12.692c2.467-8.412-4.881-16.116-10.601-22.76a82.324 82.324 0 0 1-10.856-16.135 22.21 22.21 0 0 1-2.597-7.336c-.451-3.729.747-7.44 1.954-10.996q6.03-17.774 12.896-35.25"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M9.57 468.437a13.674 13.674 0 1 0 1.822-26.225l.342 7.038-3.33-6.032a13.623 13.623 0 0 0-7.02 7.702 13.41 13.41 0 0 0-.786 3.699 13.672 13.672 0 0 0 8.973 13.818z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M23.812 429.539a13.658 13.658 0 0 1 9.842-8.671l1.126 6.69 2.088-7.026a13.673 13.673 0 1 1-13.056 9.007z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M24.563 427.123a13.658 13.658 0 0 1 9.842-8.671l1.126 6.69 2.088-7.027a13.673 13.673 0 1 1-13.056 9.008z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M34.058 501.822a13.673 13.673 0 0 0 12.101-24.325l-1.604 5.4-1.137-6.77a.238.238 0 0 0-.035-.013 13.673 13.673 0 1 0-9.325 25.708z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M34.708 499.374A13.673 13.673 0 0 0 46.81 475.05l-1.604 5.4-1.137-6.77a.238.238 0 0 0-.035-.013 13.673 13.673 0 1 0-9.326 25.707z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#57b894",
    d: "M19.822 524.53a13.667 13.667 0 1 0 2.635-10.708l6.092 9.17-8.324-4.867a13.545 13.545 0 0 0-.403 6.405z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    d: "M20.385 522.718a13.667 13.667 0 1 0 2.635-10.708l6.092 9.17-8.324-4.867a13.545 13.545 0 0 0-.403 6.405z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2f2e41",
    ry: 22,
    rx: 17,
    cy: 319.115,
    cx: 480.946
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#2f2e41",
    ry: 22,
    rx: 17,
    cy: 319.615,
    cx: 573.446
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M560.446 384.615c0 9.94-13.88 18-31 18s-31-8.06-31-18c0-8.61 10.41-15.81 24.32-17.57a50.104 50.104 0 0 1 6.68-.43 50.699 50.699 0 0 1 11.13 1.2c11.62 2.59 19.87 9.14 19.87 16.8z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    ry: 22,
    rx: 17,
    cy: 314.115,
    cx: 484.946
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    ry: 22,
    rx: 17,
    cy: 314.615,
    cx: 577.446
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    strokeMiterlimit: 10,
    stroke: "#3f3d56",
    fill: "none",
    ry: 18,
    rx: 31,
    cy: 379.615,
    cx: 533.446
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M540.946 369.315a4.937 4.937 0 0 1-1.32 3.392 4.339 4.339 0 0 1-3.18 1.408h-10a4.664 4.664 0 0 1-4.5-4.8 4.905 4.905 0 0 1 .82-2.74 47.02 47.02 0 0 1 6.68-.46 47.665 47.665 0 0 1 11.13 1.28 5.067 5.067 0 0 1 .37 1.92z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 5,
    cy: 308.115,
    cx: 484.946
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#fff",
    r: 5,
    cy: 308.115,
    cx: 577.946
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    fill: "currentColor",
    r: 5,
    cy: 355.115,
    cx: 582.946
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    fill: "currentColor",
    r: 5,
    cy: 355.115,
    cx: 460.946
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIllustration);
export default __webpack_public_path__ + "static/media/error_illustration.98346f9a.svg";
export { ForwardRef as ReactComponent };